import { T_LOGO_ICON_PATH } from '@/consts/imgPath';

const HomeHeader = (): JSX.Element => {
  return (
    <header className="main-header sticky-header" id="header">
      <a className="inner" href="#">
        <div className="img">
          <img src={T_LOGO_ICON_PATH} alt="Logo" />
        </div>
        <h1>Takk</h1>
      </a>
    </header>
  );
};

export default HomeHeader;
